(function () {
  if (window.__boosoPdpNewsletterCtaInitialized) {
    return;
  }
  window.__boosoPdpNewsletterCtaInitialized = true;

  var BUTTON_SELECTOR = '.pdp-newsletter-cta__button';
  var FALLBACK_FORM_SELECTORS = [
    '.popup__newsletter',
    '.newsletter-form',
    "form[action*='contact']"
  ];

  var LAUNCHER_SELECTORS = [
    '[id*="getresponse"][id*="popup"]',
    '[class*="getresponse"][class*="popup"]',
    '[data-testid*="getresponse"]',
    '[data-app*="getresponse"]',
    '[data-popup*="newsletter"]',
    '[id*="newsletter"][id*="popup"]',
    '[class*="newsletter"][class*="popup"]',
    '[id*="gr"][id*="popup"]',
    '[class*="gr"][class*="popup"]',
    '[aria-label*="newsletter"]'
  ];

  function isFunction(value) {
    return typeof value === 'function';
  }

  function tryOpenViaApi() {
    var candidates = [
      { root: window.GetResponse, path: ['forms', 'open'] },
      { root: window.GetResponse, path: ['open'] },
      { root: window.getResponse, path: ['open'] },
      { root: window.gr, path: ['openPopup'] },
      { root: window.gr, path: ['popup', 'open'] },
      { root: window._gr, path: ['open'] },
      { root: window._gr, path: ['showPopup'] }
    ];

    for (var i = 0; i < candidates.length; i += 1) {
      var fn = candidates[i].root;
      var path = candidates[i].path;
      for (var p = 0; p < path.length; p += 1) {
        if (!fn) {
          break;
        }
        fn = fn[path[p]];
      }

      if (!isFunction(fn)) {
        continue;
      }

      try {
        fn();
        return true;
      } catch (error) {
      }
    }

    var windowKeys = Object.keys(window);
    for (var k = 0; k < windowKeys.length; k += 1) {
      var key = windowKeys[k];
      var normalizedKey = key.toLowerCase();
      if (normalizedKey.indexOf('getresponse') === -1 && normalizedKey.indexOf('newsletter') === -1 && normalizedKey !== 'gr' && normalizedKey.indexOf('_gr') === -1) {
        continue;
      }

      var maybeApi = window[key];
      if (!maybeApi || typeof maybeApi !== 'object') {
        continue;
      }

      var methodNames = ['open', 'show', 'openPopup', 'showPopup', 'launch'];
      for (var m = 0; m < methodNames.length; m += 1) {
        var methodName = methodNames[m];
        if (isFunction(maybeApi[methodName])) {
          try {
            maybeApi[methodName]();
            return true;
          } catch (error) {
          }
        }
      }
    }

    return false;
  }

  function clickPossibleLauncher(button) {
    for (var i = 0; i < LAUNCHER_SELECTORS.length; i += 1) {
      var nodes = document.querySelectorAll(LAUNCHER_SELECTORS[i]);
      for (var j = 0; j < nodes.length; j += 1) {
        var node = nodes[j];
        if (!node || node === button || button.contains(node) || node.contains(button)) {
          continue;
        }

        if (node.closest('.pdp-newsletter-cta')) {
          continue;
        }

        try {
          node.click();
          return true;
        } catch (error) {
        }
      }
    }

    return false;
  }

  function clickTextLauncher(button) {
    var textMatcher = /(odbierz\s*rabat|newsletter|zapisz\s*się)/i;
    var nodes = document.querySelectorAll('button, a, [role="button"]');

    for (var i = 0; i < nodes.length; i += 1) {
      var node = nodes[i];
      if (!node || node === button || button.contains(node) || node.contains(button)) {
        continue;
      }

      var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text || !textMatcher.test(text)) {
        continue;
      }

      if (node.closest('.pdp-newsletter-cta')) {
        continue;
      }

      try {
        node.click();
        return true;
      } catch (error) {
      }
    }

    return false;
  }

  function scrollToNewsletterForm() {
    for (var i = 0; i < FALLBACK_FORM_SELECTORS.length; i += 1) {
      var form = document.querySelector(FALLBACK_FORM_SELECTORS[i]);
      if (form) {
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return true;
      }
    }

    return false;
  }

  function releaseButton(button) {
    window.setTimeout(function () {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }, 900);
  }

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' zł';
  }

  function updateDiscountedPrice(price) {
    var discounted = Math.round(price * 95 / 100);
    document.querySelectorAll('[data-nl-savings]').forEach(function (el) {
      el.textContent = formatMoney(discounted);
    });
  }

  document.addEventListener('variant:change', function (event) {
    if (event.detail && event.detail.variant && event.detail.variant.price) {
      updateDiscountedPrice(event.detail.variant.price);
    }
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest(BUTTON_SELECTOR);
    if (!button) {
      return;
    }

    event.preventDefault();

    if (button.disabled) {
      return;
    }

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    var opened = false;

    opened = tryOpenViaApi();

    if (!opened) {
      opened = clickPossibleLauncher(button);
    }

    if (!opened) {
      opened = clickTextLauncher(button);
    }

    if (!opened) {
      opened = scrollToNewsletterForm();
    }

    button.setAttribute('aria-expanded', opened ? 'true' : 'false');
    releaseButton(button);
  }, true);
})();
